<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="activity-modal" *ngIf="selectedActivity">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ selectedActivity.name }}</h5>
      <ion-icon name="close" (click)="selectedActivity = null" class="close-icon"></ion-icon>
    </div>
    <div class="modal-body" [innerHTML]="selectedActivity.description"></div>
  </div>
</div>


<ion-content>
  <!-- STEP 0 -->
  <div *ngIf="!this.seeFile" style="min-height: 100%;min-width: 100%;width: 100%;height: 100%;">

    <!-- Pantalla inicial: instrucciones y botón "Siguiente" -->
    <div *ngIf="steps == 0" class="ion-text-center">
      <div class="container-info activity-description" [innerHTML]="this.template.settings[0].instructions">
        <p class="ion-text-center" style="margin: 50px 50px 100px 50px;">
          <br />
        </p>
      </div>
      <!-- Buttons moved to footer -->
    </div>

    <!-- Paso 1: listado de actividades y botones de acción -->
    <div *ngIf="steps === 1">
      <div class="mark-all-activities">
        <h6><strong>Selecciona las actividades en las que quieres participar</strong></h6>
      </div>
      <div *ngIf="ia_activities.length >= 1"
           [ngClass]="{
             'activities-grid': true,
             'two-activities': ia_activities.length === 2,
             'many-activities': ia_activities.length > 2
           }">
        <div class="act-card"
          *ngFor="let activity of ia_activities"
          (click)="markActivityChecked(activity)"
          [ngStyle]="{ 'background-image': 'url(' + activity.image + ')' }"
          [ngClass]="{ 'is-checked': activity.checked }">
          <ion-checkbox id="checkboxActivity" [(ngModel)]="activity.checked"
          [disabled]="true"></ion-checkbox>
          <div class="view-activity-rules">
            <span (click)="selectActivity(activity, $event)">Ver Reglas de la Actividad</span>
          </div>
          <h3 class="activity-title">{{ activity.name }}</h3>
        </div>
      </div>
    </div>

    <!-- LOADING for multiple invoices (STEP 2) -->
    <div *ngIf="steps === 2 && template?.settings[0]?.allow_multiple_invoices" class="loader-container">
<!-- 
      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="showLegend = !showLegend" size="small" color="light">
          <ion-icon name="help-outline"></ion-icon>
        </ion-fab-button>
      </ion-fab> -->

      <!-- Legend -->
      <div class="floating-help-text" *ngIf="showLegend">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <b>¿Qué hace cada ícono?</b>
          <ion-icon name="close" style="cursor: pointer;" (click)="showLegend = false"></ion-icon>
        </div>

        <div class="legend-row">
          <ion-icon name="eye-outline" color="primary"></ion-icon>
          <span>Ver</span>
        </div>
        <div class="legend-row">
          <ion-icon name="checkmark-circle-outline" color="success"></ion-icon>
          <span>{{ this.template.settings[0].upload_activity_button }}</span>
        </div>
        <div class="legend-row">
          <ion-icon name="close-circle-outline" color="danger"></ion-icon>
          <span>Descartar</span>
        </div>
        <div class="legend-row">
          <ion-icon name="warning-outline" color="warning"></ion-icon>
          <span>Ver motivos de no aprobación</span>
        </div>
      </div>

      <ion-list style="margin: 10px;">
        <ion-item *ngFor="let item of uploadFiles" style="padding: 10px; border-radius: 10px; border: solid 1px #ccc; margin: 10px;">


          <ion-label *ngIf="item.state === 'uploading'" style="display: flex; flex-direction: column; align-items: center; "> 
            <div *ngIf="item.state === 'uploading'" style="font-weight: bold; font-size: 15px;">{{ item.name || 'Archivo' }}</div>

            <div style="font-size: 14px; margin-top: 4px;">
              <ion-icon name="cloud-upload" *ngIf="item.state === 'uploading'" color="primary"></ion-icon>
            </div>

          <ion-progress-bar
            *ngIf="item.state === 'uploading'"
            [value]="item.progress! / 100"
            type="determinate"> 
          </ion-progress-bar>
          <span style="padding: 5px; font-size: small;"> <b>{{ loadingMessage }}</b> </span>
        </ion-label>
        <ion-label *ngIf="item.state === 'success'" class="success-label">
          <div class="success-content">
            <ion-icon
              [name]="getResultIcon(item.result_status)"
              [color]="getResultColor(item.result_status)"
              class="result-icon">
            </ion-icon>
            
            <h3 class="result-text" [style.color]="getResultColorHex(item.result_status)">
              {{ getStatusMessage(item) }}
            </h3>
          </div>
        </ion-label>
        <ion-label *ngIf="item.state === 'sending' || item.state === 'send'">
          <div *ngIf="item.state === 'sending'" style="font-size: 14px; margin-top: 4px;">
            <ion-icon name="cloud-upload" color="primary"></ion-icon>
            <span style="margin-left: 8px;">Enviando...</span>
          </div>
          <div *ngIf="item.state === 'send'">
            <h3> Enviado correctamente </h3>
          </div>
        </ion-label>
        <ion-label *ngIf="item.state === 'error'">
          <div *ngIf="item.state === 'error'" style="font-size: 14px; margin-top: 4px;">
            <ion-icon name="cloud-upload" color="danger"></ion-icon>
            <span style="margin-left: 8px;">Error al procesar</span>
          </div>
        </ion-label>
        <div slot="end" *ngIf="item.state === 'success' || item.state !== 'sending' || item.state !== 'send' || item.state !== 'error'">
          <span title="Ver" style="cursor: pointer" (click)="viewImage(item)">
          <ion-icon *ngIf="item.file && item.state === 'success'"
                    name="eye-outline"
                    matTooltip="Ver"
                    color="primary"
                    style="font-size: 23px; margin-right: 8px; cursor: pointer; margin: 0px 10px 0px 10px; pointer-events: none;">
        </ion-icon>
        </span>
        <span title="Enviar factura" style="cursor: pointer" (click)="showQuestionsByResult(item)">
          <ion-icon *ngIf="item.state === 'success' && item.result_status === 'APPROVED' || item.result_status === 'MANUAL_VALIDATION' && item.state !== 'error'"
                    name="checkmark-circle-outline"
                    aria-hidden="true"
                    color="success"
                    style="font-size: 23px; margin-right: 8px; cursor: pointer; margin: 0px 10px 0px 10px; pointer-events: none;">
          </ion-icon>
        </span>
        <span title="Descartar" style="cursor: pointer" (click)="removeFromQueue(item)">
          <ion-icon *ngIf="item.state === 'success' && item.result_status === 'APPROVED' || item.result_status === 'MANUAL_VALIDATION' || item.result_status === 'REJECTED'"
                    name="close-circle-outline"
                    aria-hidden="true"
                    color="danger"
                    style="font-size: 23px; cursor: pointer; margin-right: 8px; margin: 0px 10px 0px 10px; pointer-events: none;">
          </ion-icon>
        </span>
        <span title="Ver motivos de no aprobación" style="cursor: pointer" (click)="viewRejectReasons(item)">
          <ion-icon *ngIf="item.state === 'success' && item.result_status === 'REJECTED'"
                    name="warning-outline"
                    color="warning"
                    aria-hidden="true"
                    style="font-size: 23px; margin-right: 8px; cursor: pointer; margin: 0px 10px 0px 10px; pointer-events: none;">
          </ion-icon>
        </span>
        </div>
        </ion-item>
      </ion-list>

      <div class="modal-overlay" *ngIf="seeResults">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Resultados</h3>
            <button class="close-btn" (click)="seeResults = false" aria-label="Cerrar">×</button>
          </div>
          <div class="modal-body">
            <ul class="result-list">
              <li *ngFor="let rule of reasons">{{ rule.message }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: center; align-items: center;">
      <ion-button expand="full" (click)="filesInput.click()" color="primary">
        Agregar archivo
      </ion-button>
      <input type="file" #filesInput (change)="onFilesSelected($event)" hidden />
    </div>

    </div>

    <!-- LOADING (STEP 2) -->
    <div *ngIf="steps == 2 && !this.template.settings[0].allow_multiple_invoices" class="loader-container">
      <div class="loader-container-center ion-text-center">
        <!-- <p>{{ progressPercent }}%</p> -->
        <ion-spinner name="crescent"></ion-spinner>
        <h3>{{ loadingMessage }}</h3>
        <ion-progress-bar [value]="progressPercent/100"></ion-progress-bar>
      </div>
    </div>

    <!-- Elección de actividades (STEP 3) -->
    <div *ngIf="steps == 3">
      <div class="container-info">
        <p style="padding: 20px; font-size: 20px; margin: 0;">
          <b>NO OLVIDES</b> dar clic en <b>“Enviar factura”</b> para acumular Duracoins
        </p>
        <div class="container-activities">
          <div *ngFor="let result of ia_result" class="activity-wrapper">
            <div class="activity-card" (click)="onActivitySelect(result.activity.id, result.result.final_state)"
              [ngClass]="[
                result.result.final_state === 'APPROVED' ? 'approved' :
                result.result.final_state === 'MANUAL_VALIDATION' ? 'pending' : 'rejected',
                isSelected(result.activity.id) ? 'selected' : ''
              ]" [ngStyle]="{'background-image': 'url(' + result.activity.image + ')'}">
              <div class="status-label"
                [ngClass]="result.result.final_state === 'APPROVED' ? 'approved' : (result.result.final_state === 'MANUAL_VALIDATION' ? 'pending' : 'rejected')"
                (click)="result.result.final_state === 'REJECTED' ? openReason(result) : null">
                <span class="status-icon">
                  {{ result.result.final_state === 'APPROVED' ? '✔' : (result.result.final_state === 'MANUAL_VALIDATION'
                  ? '⌛' : '✘') }}
                </span>
                {{ getStateLabel(result.result.final_state) }}
              </div>
              <!-- <p class="activity-name" (click)="result.result.final_state === 'REJECTED' ? (openReason(result); $event.stopPropagation()) : null"> -->
              <p *ngIf="selectedActivitiesCheckpoint.length > 1" class="activity-name" (click)="$event.stopPropagation()">
                {{ result.activity.name }}
              </p> 
              <span class="view-failed-rules-button" *ngIf="selectedActivitiesCheckpoint.length > 1 && result.result.final_state === 'REJECTED'"
                (click)="openReason(result); $event.stopPropagation()" 
                title="¿Por qué fue rechazado?">
              Ver Razones de Rechazo
            </span>
              <!-- <button *ngIf="selectedActivitiesCheckpoint.length > 1 && result.result.final_state === 'REJECTED'" class="reason-button"
                (click)="openReason(result); $event.stopPropagation()" title="¿Por qué fue rechazado?">
                ⚠️
              </button> -->
            </div>
            <div *ngIf="selectedActivitiesCheckpoint.length === 1 && result.result.final_state === 'REJECTED'">
            <p style="padding: 20px; font-size: 20px; margin: 0;">
              El estado de tu factura quedo <b>NO APROBADA</b>. Por las siguientes razones:
            </p>
          <div style="display: flex; flex-direction: column; align-items: flex-start; max-width: 55%; margin: auto;" >
            <ul *ngFor="let reason of result.result.failed_rules" >
              <li>{{ reason.message }}</li>
          </ul> 
          </div>
            </div>
            <div *ngIf="selectedActivitiesCheckpoint.length === 1 && result.result.final_state === 'MANUAL_VALIDATION'">
              <p style="padding: 20px; font-size: 20px; margin: 0;">
                Tu factura se encuentra <b>EN VALIDACIÓN</b>. <b>NO OLVIDES</b> dar clic en <b>"Enviar factura"</b> para completar el proceso
              </p>
            </div>

            <div *ngIf="selectedActivitiesCheckpoint.length === 1 && result.result.final_state === 'APPROVED'">
              <p style="padding: 20px; font-size: 20px; margin: 0;">
                <b>NO OLVIDES</b> dar clic en <b>“Enviar factura”</b> para acumular Duracoins
              </p>
            </div>
          </div>

        </div>

        <!-- Buttons moved to footer -->
      </div>
    </div>

    <!-- Paso 4: confirmación de subida -->
    <div *ngIf="steps == 4" class="loader-container">
      <div class="loader-container-center ion-text-center">
        <div *ngIf="isLoading" class="ion-text-center">
          <ion-spinner name="crescent"></ion-spinner>
          <h3>Enviando archivo...</h3>
        </div>
        <div *ngIf="!isLoading" class="container-info info-margin">
          <h3>
            <ion-icon name="checkmark-circle-outline" style="color: green;"></ion-icon>
          </h3>
          <h3>El archivo se ha subido con éxito</h3>
          <!-- Buttons moved to footer -->
        </div>
      </div>
    </div>

    <!-- Modal con reglas inválidas -->
    <div class="modal-overlay" *ngIf="activeReason">
      <div class="modal-content">
        <div class="modal-header">
        <button class="close-btn" (click)="closeReason()">×</button>
        <h3>Reglas incumplidas</h3>
      </div>
      <div class="modal-body">
        <ul class="result-list" *ngIf="activeReason?.result?.failed_rules && activeReason.result.failed_rules.length" style="padding-top: 10px;">
          <li *ngFor="let rule of activeReason.result.failed_rules" style="padding: 4px 0;">{{ rule.message }}</li>
        </ul>
        <p *ngIf="!activeReason?.result?.failed_rules || !activeReason.result.failed_rules.length" style="margin-top: 10px; color:#666">No se encontraron
          detalles.</p>
        </div>
      </div>
    </div>


    <!-- Vista de previsualización de archivo (cuando seeFile == true) -->
    <div *ngIf="isLoading && seeFile" class="ion-text-center">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Cargando...</p>
    </div>

    <div *ngIf="!isLoading && seeFile">
      <div *ngFor="let result of resultIa.results" class="result-item">
        <div *ngIf="resultIa.count > 0">
          <h2 class="ion-text-center">{{ result.ia_activity }}</h2>
          <div class="state-container">
            <span
              [ngClass]="{'badge-approved': result.state === 'APPROVED','badge-rejected': result.state === 'REJECTED','badge-pending': result.state === 'MANUAL_VALIDATION'}"
              class="state-badge">
              {{ getStateLabel(result.state) }}
            </span>
          </div>

          <img [src]="result.files" alt="Archivo" class="result-image" />
        </div>
      </div>

      <div *ngIf="resultIa.count == 0">
        <h2 class="ion-text-center padding-top-sm">No se encontraron resultados</h2>
      </div>
    </div>
  </div>

  <!-- Cierre de <div *ngIf="!this.seeFile"> -->
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="mark-all-activities" *ngIf="steps === 1">
      <ion-checkbox [(ngModel)]="markAllActivities" (click)="toggleAllActivities()"></ion-checkbox>
      <h6>Participar en todas las actividades</h6>
    </div>
    <ion-buttons *ngIf="steps == 0">
      <button class="z-depth-2 bigButton" (click)="this.steps=1">
        Siguiente
      </button>
    </ion-buttons>

    <p 
    *ngIf="this.steps == 2 && template?.settings[0].allow_multiple_invoices && this.uploadFiles.length > 1" 
    style="margin: 0px; display: flex; justify-content: center; flex-wrap: wrap; text-align: center; padding: 10px;"
    > 
    <b>NO OLVIDES</b>&nbsp;
    dar clic en 
    <b>&nbsp;"{{ this.template.settings[0].upload_multiple_activity_button || this.template.settings[0].upload_activity_button }}"&nbsp;</b>
    para continuar con el proceso
  </p>
  
  
  <ion-buttons *ngIf="steps == 1">
    <input type="file" accept="image/*,.pdf" (change)="onFileSelected($event)" hidden #fileInput />
    <input type="file" accept="image/*,.pdf" (change)="onFilesSelected($event)" hidden #filesInput />
    <button class="z-depth-2 bigButton" (click)="openModalResume()">
      Ver Resumen
    </button>
    <button *ngIf="this.playerData?.level?.id == 46" class="z-depth-2 bigButton"
        style="margin-bottom: 0;margin-top: 0; background-color: var(--ion-color-primary); font-size: medium;"
        (click)="validatedocumentDuratex()">
        Valida si tu carpintero está registrado
      </button>
      <button *ngIf="!this.template.settings[0].allow_multiple_invoices && selectedActivities.length >= 1" class="z-depth-2 bigButton" (click)="fileInput.click()">
        {{ this.template.settings[0].upload_file_button }}
      </button>
      <button *ngIf="this.template.settings[0].allow_multiple_invoices && selectedActivities.length >= 1" class="z-depth-2 bigButton" (click)="filesInput.click()">
        {{ this.template.settings[0].upload_file_button }}
      </button>
    </ion-buttons>

    <ion-buttons *ngIf="steps == 3">
      <button class="z-depth-2 bigButton" style="background-color: gray;" (click)="goBack()">
        Regresar
      </button>
      <button *ngIf="ia_result.length == 1 && ia_result[0].result.final_state !== 'REJECTED'" class="z-depth-2 bigButton" (click)="showResult(ia_result)"
        [disabled]="selectedActivities.length === 0">
        {{ this.template.settings[0].upload_activity_button }}
      </button>
      <button *ngIf="ia_result.length > 1" class="z-depth-2 bigButton" (click)="showResult(ia_result)"
        [disabled]="selectedActivities.length === 0">
        {{ this.template.settings[0].upload_multiple_activity_button || this.template.settings[0].upload_activity_button }}
      </button>
    </ion-buttons>

    <ion-buttons *ngIf="steps == 4 && !isLoading">
      <button class="z-depth-2 bigButton" (click)="goFirstStep()">Envíar otro archivo</button>
    </ion-buttons>

    <ion-buttons *ngIf="this.steps == 2 && template?.settings[0].allow_multiple_invoices"
    style="margin: 0px 30px 0px 30px; gap: 25px;">
      <button class="z-depth-2 bigButton" style="background-color: gray; margin-bottom: 15px; margin-top: 0;" (click)="goBack()">
        Regresar
      </button>
      <button *ngIf="this.uploadFiles.length > 1" 
              class="z-depth-2 bigButton" style="margin-bottom: 15px; margin-top: 0;" (click)="sendAllFiles()">
      {{ this.template.settings[0].upload_multiple_activity_button || this.template.settings[0].upload_activity_button }}
      </button>
    </ion-buttons>
    
  </ion-toolbar>


</ion-footer>